import { graphql } from '@repo/common/queries/schemas/server_user_query'

export const mutation_reset_password = graphql(`
  mutation reset_password_email($input: ResetPasswordInput!) {
    reset_password_email(input: $input) {
      status
    }
  }
`)

export const mutation_confirm_email = graphql(`
  mutation send_confirm_email {
    send_confirm_email {
      status
    }
  }
`)
